export default __webpack_public_path__ + "static/media/backdrop.1f3c12e7.png";